<template>
  <section class="page3">
    <article class="container">
      <wl-title title='联系我们' :isNeedDesc=false></wl-title>
      <section class="flexWrap">
        <section v-for="(item,idx) in page3Data" :key="item.key" class="flexWrap_item">
          <section class="flex">
<!--            <section class="_icon " :style="`background-position: -${80*idx}px -277px;`"></section>-->
            <h3>{{item.title}}</h3>
          </section>
          <p class="flexWrap_text">{{item.desc}}</p>
        </section>
      </section>
      <section class="img"><img src="/static/img/about/wl-loc.png" alt="广东省深圳市龙华区油松路天汇大厦C栋308"></section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'contactPage',
  data() {
    return {
      page3Data: [
        { title: '电话', desc: '18688780529', key: 'about-tel' },
        // { title: 'QQ', desc: 'xxxxx', key: 'about-qq' },
        { title: '地址', desc: '广东省深圳市龙华区油松路天汇大厦C栋308', key: 'about-add' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/about/icon-sprite.png");
}
p {
  white-space: pre-line;
  font-size: 24px;
  line-height: 24px;
  color: #8e8e8e;
  padding-top: 6px;
}
h3 {
  font-size: 24px;
  line-height: 24px;
  color: #262626;
  padding-left: 12px;
}
.flexWrap_item:nth-child(4) {
  width: 25%;
}
.page3 {
  height: 832px;
  padding-top: 136px;
  ._icon {
    height: 63px;
    width: 60px;
  }
  .flexWrap {
    padding-top: 66px;
    padding-bottom: 32px;
  }
  .flex {
    text-align: left;
    align-items: center;
    section {
      margin-left: 8px;
    }
  }
  .flexWrap_text {
    line-height: 1.5;
    text-align: left;
  }
}
</style>
